/**
 * Asserts that the given environment variable exists and has been properly defined.
 *
 * @param variableName - The NAME of the environment variable that is to be checked.
 * @param variableValue - The VALUE of the environment variable that is to be checked.
 *
 * @throws Error - if the variable is missing or empty.
 *
 * @example - usage:
 * assertEnvVariableExists('APP', process.env.APP)
 */
export const assertEnvVariableExists: (
  variableName: string,
  variableValue: unknown
) => asserts variableValue is NonNullable<typeof variableValue> = (variableName, variableValue) => {
  if (typeof variableValue !== 'string' || variableValue.length === 0) {
    throw new Error(`Environment variable '${variableName}' is missing or empty!`);
  }
};
